import * as Macy from 'macy';

export function initializeMacy() {
    let macyContainers = document.querySelectorAll('[data-macy-container]');

    if (!macyContainers) return;

    [].forEach.call(macyContainers, (container) => createMacy(container));
}

function createMacy(container: HTMLElement) {
    let macy = Macy({
        container: `#${container.id}`,
        trueOrder: true,
        waitForImages: false,
        margin: 24,
        columns: 3,
        breakAt: {
            960: 2,
            600: 1
        }
    });
}